import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { getGridFinalValue } from '../list-grid/grid-utils';
import {
  ColumnCustomFilterFunction,
  ColumnFilterModel,
} from './column-filter.types';

@Component({
  selector: 'custom-filter',
  template: ``, // no gui, just empty template
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  private filterModel: ColumnFilterModel = {};
  private filterValue: any = null;
  private customFilterFunction: ColumnCustomFilterFunction;

  public agInit(
    params: IFilterParams & {
      customFilter?: ColumnCustomFilterFunction;
    },
  ): void {
    this.params = params;
    this.customFilterFunction = params?.customFilter || this.defaultFilter;
  }

  private defaultFilter(): boolean {
    return true; // show all as default
  }

  // Core filtering logic
  public doesFilterPass(params: IDoesFilterPassParams): boolean {
    const { cellValue } = getGridFinalValue(params.data, this.params.colDef);

    return this.customFilterFunction({
      cellValue,
      rowData: params.data,
      filterModel: this.filterModel,
    });
  }

  // Check if filter is active
  public isFilterActive(): boolean {
    return this.filterValue !== null;
  }

  // Get filter model (for saving/restoring state)
  public getModel(): any {
    return this.isFilterActive() ? this.filterModel : null;
  }

  // Set filter model
  public setModel(model: ColumnFilterModel): void {
    this.filterValue = model ? model : null;
    this.filterModel = model;
  }

  // Method to set filter value (can be called externally)
  public setFilterValue(value: any): void {
    this.filterValue = value;
    this.params.filterChangedCallback();
  }

  // Clear filter
  public clearFilter(): void {
    this.filterValue = null;
    this.filterModel = {};
    this.params.filterChangedCallback();
  }
}
